/** The year word over a page's title - `FY2025`, or `FY2025-26` for a year that crosses a calendar
 * year (Q-03, G-Wauditor-18).
 *
 * The period's own "FY" word when its label has one, else the year it ends in. The pattern used to
 * stop at the first character that was not a number, so a UK April year labelled `FY2025-26` was
 * printed `FY2025` on every screen while the Engagement page, the figures and the filing all said
 * `FY2025-26`: a kicker that followed the year's start and not the year. A second part is taken only
 * when it is the year's last two or all four numerals, so a label such as `FY2025-Q1` keeps `FY2025`.
 */
export function fiscalWord(label: string, periodEnd: string): string {
  return /FY\d{2,4}(?:-(?:\d{4}|\d{2})(?!\d))?/.exec(label)?.[0] ?? `FY${periodEnd.slice(0, 4)}`;
}
